import * as React from "react";

interface ButtonSkeletonProps {
  className: string;
}

export default function ButtonSkeleton({ className }: ButtonSkeletonProps) {
  return (
    <div className={`${className} relative button-transition`}>
      <svg
        className="w-full relative z-0"
        width="196"
        height="125"
        viewBox="0 0 196 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99996 0H187.954V7.6179H195.542V117.382H187.954V125H7.99996V117.382H0.412292V7.6179H7.99996V0Z"
          fill="#4A5568"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.954 3.41597C187.954 5.95527 187.924 8.46433 187.924 11.0036H195.542V117.382H187.954V125H11.6179V117.382C9.0786 117.382 6.5393 117.382 4 117.382V11.0036H11.6179V3.41597L187.954 3.41597Z"
          fill="#525252"
        />
      </svg>

      <div className="absolute w-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center z-15 text-center">
        <div className="flex flex-col items-center justify-center space-y-3">
          <div className="relative">
            <svg
              className="w-6 h-6 animate-spin text-[#0099FE]"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="3"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>

          <div className="flex flex-col items-center space-y-2">
            <div className="text-[14px] text-[#0099FE] font-silkscreen tracking-wider opacity-80">
              LOADING
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
